module.exports = __webpack_public_path__ + "Group81(1).svg?013bd3474284fccc83f3e0b29ee21d7d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Group81(1).svg
// module id = 89
// module chunks = 0